var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "lpu-tab d-flex align-center gc-4 pa-2 border-sm border-transparent",
      attrs: { "data-qa": "appointment_data_lpu" },
    },
    [
      _c("span", { staticClass: "ui-icon-place icon-secondary--text" }),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "text-body-1 text--text",
            attrs: { "data-qa": "appointment_data_lpu_name" },
          },
          [_vm._v("\n      " + _vm._s(_vm.lpu.name) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-body-2 text-secondary--text",
            attrs: { "data-qa": "appointment_data_lpu_address" },
          },
          [_vm._v("\n      " + _vm._s(_vm.lpu.address) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pa-4 ml-auto" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }